// import React from "react";

// const categories = [
//   { title: "Ultrasound", json: "ultrasound", bg: "/images/services/Ultrasound.jpg" },
//   { title: "X-Ray", json: "xray", bg: "/images/services/x-ray.jpg" },
//   { title: "Echo", json: "echo", bg: "/images/services/Echo.jpg" },
//   { title: "ECG", json: "ecg", bg: "/images/services/ECG.png" }
  

// ];

// const CategoryCards = ({ onSelect }) => {
//   return (
//     <div className="grid grid-cols-2 gap-4 p-4">
//       {categories.map((cat) => (
//         <div
//           key={cat.json}
//           onClick={() => onSelect(cat)}
//           className="group relative h-40 bg-cover bg-center rounded-xl shadow-md cursor-pointer transition-transform duration-300 md:hover:scale-105"
//           style={{ backgroundImage: `url(${cat.bg})` }}
//         >
//           <div className="absolute inset-0 bg-black bg-opacity-40 rounded-xl transition duration-300 md:group-hover:bg-opacity-60 flex items-center justify-center">
//             <div className="text-white text-lg sm:text-xl font-bold transition-transform duration-300 md:group-hover:scale-110">
//               {cat.title}
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default CategoryCards;



import React from "react";

const categories = [
  { title: "Ultrasound", bg: "/images/services/Ultrasound.jpg" },
  { title: "X-Ray", bg: "/images/services/x-ray.jpg" },
  { title: "Echo", bg: "/images/services/Echo.jpg" },
  { title: "ECG", bg: "/images/services/ECG.png" }
];

const CategoryCards = () => {
  const phoneNumber = "+919900500950";

  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <div className="grid grid-cols-2 gap-4 p-4">
      {categories.map((cat, index) => (
        <div
          key={index}
          onClick={handleCall}
          className="group relative h-40 bg-cover bg-center rounded-xl shadow-md cursor-pointer transition-transform duration-300 md:hover:scale-105"
          style={{ backgroundImage: `url(${cat.bg})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40 rounded-xl transition duration-300 md:group-hover:bg-opacity-60 flex items-center justify-center">
            <div className="text-white text-lg sm:text-xl font-bold transition-transform duration-300 md:group-hover:scale-110">
              {cat.title}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CategoryCards;
